export abstract class FilterOptionsBase {}